import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import { VerticalTab } from 'app/shared/models/verticaltab';
import {Observable} from 'rxjs';

@Component({
    selector: 'vertical-tabs',
    templateUrl: './vertical-tabs.component.html',
    styleUrls: ['./vertical-tabs.component.scss'],
    standalone: false
})
export class VerticalTabsComponent implements OnInit {

  constructor() {
  }

  tabs: VerticalTab[] = [];

  @Output() selected = new EventEmitter<{selectedTab: VerticalTab}>();
  @Input() beforeSelectTabCheck?: (tab: VerticalTab) => Observable<boolean>;

  addTab(tab: VerticalTab, pos?: string) {
    if (!tab.isPreSelected && !this.tabs.length) {
      tab.selected = true;
    }

    if (pos !== undefined)
      this.tabs.splice(+pos, 0, tab);
    else
      this.tabs.push(tab);

    if (tab.isPreSelected && tab.selected) {
      this.selectTab(tab);
    }
  }

  public selectTab(tab: VerticalTab) {
    if (this.beforeSelectTabCheck) {
      this.beforeSelectTabCheck(tab).subscribe((result) => {
        if (result) {
          this.tabs.map((_tab) => {
            _tab.selected = false;
          });
          tab.selected = true;
          this.selected.emit({selectedTab: tab});
        }
      });
    } else {
      this.tabs.map((_tab) => {
        _tab.selected = false;
      });
      tab.selected = true;
      this.selected.emit({selectedTab: tab});
    }
  }

  ngOnInit() {
  }

}
